import { createSelector } from 'reselect'
import featureScopesSelector from './featureScopesSelector'

const hideCheckoutWithoutDealerIdEnabledSelector = createSelector(
    featureScopesSelector,
    (featureScopes): boolean => featureScopes.includes('hideCheckoutWithoutDealerId'),
)

export default hideCheckoutWithoutDealerIdEnabledSelector
